import { formatMessage } from "model/message";

const MAX_BUY_MEDICINE = 13;
const MAX_HEALTH = 100;
const WORKED_THRESHOLD = 6;

const messageText = ({ cost, gain }) => {
  const text = gain.health > WORKED_THRESHOLD
    ? "the bitterness goes down and stays down"
    : "snake oil. she counts the coin anyway";

  return formatMessage(text, { gain, cost });
};

const attempt = ({ context, prices: { medicine } }) => {
  const resilience = context.party.traits.getTraitValue("resilience") || 0;
  const resilienceBonus = Math.ceil(resilience / 5); // Example: Every 5 points of resilience add 1 to health gain

  const baseHealthGain = Math.random() * MAX_BUY_MEDICINE;
  const enhancedHealthGain = Math.ceil(
    Math.min(
      MAX_HEALTH - context.party.resources.attribs.health.value,
      baseHealthGain + resilienceBonus,
    ),
  );

  const result = {
    success: true,
    cooldown: 0.2,
    gain: {
      health: enhancedHealthGain,
    },
    cost: { coins: medicine },
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const { resources } = context.party;
  const { gain, cost } = result;

  resources.delta({ health: gain.health, coins: -cost.coins }, context);

  const message = messageText(result);
  return { message };
};

const buyMedicine = ({ context, prices }) => ({
  title: "Pay Healer",
  hotkey: "h",
  enabled: () => {
    return (
      context.party.resources.attribs.coins.value >= prices.medicine &&
      context.party.resources.attribs.health.value < MAX_HEALTH
    );
  },
  execute: (context) => {
    const result = attempt({ context, prices });
    const { message } = executeSideEffects(context, result);

    return { result: { message } };
  },
  tooltips: [["coins", `${prices.medicine}`]],
});

export default buyMedicine;
